<template>
  <!-- =============== PARENT NAVIGATION DRAWER ===================== -->
  <v-navigation-drawer
    style="transition: 0.5s"
    mini-variant-width="60"
    :mini-variant="mini"
    v-model="drawer"
    app
    permanent
  >
    <v-row class="fill-height" no-gutters>
      <!-- ================== MINI SIDEBAR NAV DRAWER ================= -->
      <v-navigation-drawer
        mini-variant-width="60"
        permanent
        mini-variant
        color="#3c3c3c"
        class="pa-24 mini"
      >
        <!-- ================ LOGO CONTAINER ================ -->
        <div class="Dtunes-title-name d-flex align-center" style="">
          <div style="position: absolute; right: 0">
            <v-img
              width=""
              src="@/assets/Global/images/svg/sideBarTop.svg"
            ></v-img>
          </div>

          <!-- ============= LOGO IMAGE ==================== -->
          <div class="">
            <v-img
              alt="DTunes Logo"
              class="shrink mr-2 auth-layout-logo"
              contain
              width="38px"
              src="@/assets/Global/images/svg/dark-logo.svg"
              transition="scale-transition"
            />
          </div>
        </div>

        <!-- ============= NAVS CONTAINER ==================== -->
        <v-list nav dense rounded dark>
          <!-- ============ HOVER NAVS ================= -->
          <v-tooltip
            content-class="custom-tooltip"
            v-for="(item, i) in permittedNavs"
            :key="item.title"
            color="white"
            class="text-red"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- ============ NAV LISTS ============ -->
              <v-list-item
                v-bind="attrs"
                v-on="on"
                style="
                  padding-top: 5px;
                  padding-bottom: 5px;
                  margin-bottom: 10px;
                "
                :to="item.to"
                link
                @click.stop="
                  subNavs(i);
                  mini = item.mini;
                "
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span style="color: #3c3c3c; font-size: 16px"
              ><b>{{ item.title }}</b></span
            >
          </v-tooltip>
          <div style="position: absolute; left: 0">
            <v-img src="@/assets/Global/images/svg/sideBarMiddle.svg"></v-img>
          </div>
          <div style="position: absolute; right: 0">
            <v-img src="@/assets/Global/images/svg/sideBarBottom.svg"></v-img>
          </div>
        </v-list>
      </v-navigation-drawer>

      <!-- ================== SUB NAVS ===================== -->
      <v-list v-show="this.subNavItem.length !== 0" class="sub-nav">
        <h3>{{ $route.meta.nav }}</h3>
        <v-list-item
          v-for="subnav in this.subNavItem"
          :key="subnav.to"
          :to="subnav.to"
          link
        >
          <v-list-item-title class="sub-nav-link">
            {{ subnav.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
// import * as ROUTES from "@/http/routes.js";
import Navigations from "@/http/navigations.js";

export default {
  components: {},
  data: () => ({
    drawer: true,
    mini: true,
    items: [],
    itemsBottom: [],
    subNavItem: [],
  }),
  computed: {
    permittedNavs: function () {
      return this.items.filter((item) => this.can(item.permissions[0]));
    },
    permittedSubNavs: function () {
      return this.subNavItem.filter((item) => this.can(item.permissions[0]));
    }
  },
  methods: {
    subNavs(index) {
      this.subNavItem = [];
      const Nav = this.permittedNavs[index];
      if (Nav.subNav) {
        this.subNavItem = Nav.subNav;
        this.mini = false;
      }
    },
    navWatcher(){
      let objNav = this.permittedNavs.find(obj => obj.to == this.$route.path || obj.subNavs.to == this.$route.path);
      if (objNav.subNav) {
        this.subNavItem = objNav.subNav;
        this.mini = false;
      }
    }
  },
  async mounted() {
    this.items = await Navigations;
    this.navWatcher();
  },
  watch:{
    $route(){
      this.navWatcher();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
.mini {
  background: $Dtunes-blackbg;
}
.Dtunes-title-name {
  height: 100px;
  justify-content: center;
}
.v-list-item__title {
  font-size: 14px !important;
  letter-spacing: 2px !important;
}

.v-list-item--active:before {
  background-color: #fff !important;
  opacity: unset !important;
}
.v-list-item--active .v-list-item__title,
.v-list-item--active i {
  z-index: 999;
  color: #3c3c3c !important;
}
.sub-nav {
  padding-left: 10px;
  padding-top: 50px;
  width: auto;

  h3 {
    margin-bottom: 60px;
    font-weight: 600;
    font-family: "Inter", sans-serif;
    font-size: 22px;
    color: $Dtunes-text;
    letter-spacing: 1px;
  }

  .sub-nav-link {
    font-weight: 600 !important;
    background: none !important;
    font-family: "Inter", sans-serif !important;
    font-size: 12px !important;
    color: $Dtunes-text !important;
  }
  .v-list-item--active .v-list-item__title {
    color: $Dtunes-orange !important;
  }
}

.custom-tooltip {
  opacity: 1 !important;
  padding: 10px;
  box-shadow: 0px 2px 11px rgba(182, 180, 180, 0.25);
}
.custom-tooltip::before {
  content: "";
  width: 0px;
  height: 0px;
  border: 0.8em solid transparent;
  position: absolute;
  left: -20px;
  border-right: 10px solid #fff;
}
</style>
